export enum ModeId {
  Desktop = 'desktop',
  Mobile = 'mobile',
}

export interface Mode {
  title: string;
  modeId: ModeId;
}
